import classNames from "classnames";

import AscBaselineAssessmentAttemptSingle, {
  AscBaselineAssessmentAttemptSingleProps,
} from "./AscBaselineAssessmentAttemptSingle";
import styles from "./AscBaselineAssessmentAttempt.module.scss";

export interface AscBaselineAssessmentAttemptProps {
  attempts: [
    AscBaselineAssessmentAttemptSingleProps,
    AscBaselineAssessmentAttemptSingleProps,
    AscBaselineAssessmentAttemptSingleProps
  ];
  className?: string;
}

function AscBaselineAssessmentAttempt({
  attempts,
  className,
}: AscBaselineAssessmentAttemptProps) {
  return (
    <div className={classNames(styles.attemptList, className)}>
      {attempts &&
        attempts.length > 0 &&
        attempts.map((el) => (
          <AscBaselineAssessmentAttemptSingle
            key={el.attempt}
            attempt={el.attempt}
            attemptResult={el?.attemptResult}
            totalCount={el?.totalCount}
            count={el?.count}
            className={el?.className}
          />
        ))}
    </div>
  );
}

AscBaselineAssessmentAttempt.Single = AscBaselineAssessmentAttemptSingle;

export default AscBaselineAssessmentAttempt;
